import {
  Check,
  CheckCircle,
  Checks,
  EnvelopeSimple,
  ExclamationMark,
  FileText,
  FileX,
  HandsClapping,
  Handshake,
  ListChecks,
  SealWarning,
  UserCircleCheck,
  WarningCircle,
  X,
  XCircle,
} from '@phosphor-icons/react'
import { CSSProperties } from 'react'

import cn from '@/utils/tailwind/cn'

type Props =
  | {
      className?: string
      style?: CSSProperties
    }
  | undefined

const getCustomCompletePageIcons = ({ className, style }: Props = {}) => ({
  check: (
    <Check
      className={cn('text-4xl text-[#51a855]', className)}
      weight="bold"
      {...{ style }}
    />
  ),
  checks: (
    <Checks
      className={cn('text-4xl text-[#51a855]', className)}
      weight="bold"
      {...{ style }}
    />
  ),
  checkCircle: (
    <CheckCircle
      className={cn('text-4xl text-[#51a855]', className)}
      weight="bold"
      {...{ style }}
    />
  ),
  listChecks: (
    <ListChecks
      className={cn('text-4xl text-[#51a855]', className)}
      weight="bold"
      {...{ style }}
    />
  ),
  envelopeSimple: (
    <EnvelopeSimple
      className={cn('text-4xl text-[#51a855]', className)}
      weight="bold"
      {...{ style }}
    />
  ),
  fileText: (
    <FileText
      className={cn('text-4xl text-[#51a855]', className)}
      weight="bold"
      {...{ style }}
    />
  ),
  userCircleCheck: (
    <UserCircleCheck
      className={cn('text-4xl text-[#51a855]', className)}
      weight="bold"
      {...{ style }}
    />
  ),
  handshake: (
    <Handshake
      className={cn('text-4xl text-[#51a855]', className)}
      weight="bold"
      {...{ style }}
    />
  ),
  handsClapping: (
    <HandsClapping
      className={cn('text-4xl text-[#51a855]', className)}
      weight="bold"
      {...{ style }}
    />
  ),
  exclamationMark: (
    <ExclamationMark
      className={cn('text-4xl text-[#51a855]', className)}
      weight="bold"
      {...{ style }}
    />
  ),
  sealWarning: (
    <SealWarning
      className={cn('text-4xl text-[#51a855]', className)}
      weight="bold"
      {...{ style }}
    />
  ),
  warningCircle: (
    <WarningCircle
      className={cn('text-4xl text-[#51a855]', className)}
      weight="bold"
      {...{ style }}
    />
  ),
  fileX: (
    <FileX
      className={cn('text-4xl text-[#51a855]', className)}
      weight="bold"
      {...{ style }}
    />
  ),
  x: (
    <X
      className={cn('text-4xl text-[#51a855]', className)}
      weight="bold"
      {...{ style }}
    />
  ),
  xCircle: (
    <XCircle
      className={cn('text-4xl text-[#51a855]', className)}
      weight="bold"
      {...{ style }}
    />
  ),
})

export type CustomIconType = keyof typeof getCustomCompletePageIcons

export { getCustomCompletePageIcons }
